module.exports = __webpack_public_path__ + "img/03k_Store_651.ed4e6617.jpg";